import { DOCUMENT } from '@angular/common';
import { Inject, Injectable, Renderer2 } from '@angular/core';
import { AppSettingsService } from 't4-app-integration';

export type DisplayMode = 'default' | 'primary' | 'split' | 'safe' | 'danger';

export interface LayoutSettings {
  title: string,
  header: HeaderSettings;
  mode: DisplayMode;
  webMode?: DisplayMode;
}

export interface HeaderSettings {
  visible?: boolean;
  overlay?: boolean;
  showBack?: boolean;
  showMenu?: boolean;
}


@Injectable({
  providedIn: 'root'
})
export class LayoutService {

  public title: string;
  public mode: DisplayMode;
  public webMode: DisplayMode;

  public header: HeaderSettings = this.getDefaultHeaderSettings();

  public actionAreaHeight: number = 100;



  private getDefaultHeaderSettings(): HeaderSettings {
    return {
      visible: true,
      showBack: true,
      showMenu: this.appSettings?.typeSettings?.isShowMenu ?? true,
      overlay: false
    };
  }

  constructor(private appSettings: AppSettingsService, @Inject(DOCUMENT) private document: Document) { }

  public update(settings: LayoutSettings) {
    if (!settings) return;

    this.title = settings.title;
    this.mode = settings.mode;
    this.webMode = settings.webMode;

    if (settings.header) {
      this.header = this.mergeSettings<HeaderSettings>(this.getDefaultHeaderSettings(), settings.header);
    }

    this.header.showMenu = this.appSettings?.typeSettings?.isShowMenu ?? this.header.showMenu;
  }

  public clear() {
    this.title = "";
    this.mode = 'default';
    this.webMode = null;
    this.header = this.getDefaultHeaderSettings();
  }

  private mergeSettings<T>(obj1: T, obj2: T): T {
    var ret = { ...obj1 };

    for (var key in obj2) {
      if (obj2[key] !== undefined && obj2[key] !== null)
        ret[key] = obj2[key];
    }
    return ret
  }

  public loadJsScript(renderer: Renderer2, src: string, id:string): HTMLScriptElement {
    const script = renderer.createElement('script');
    script.type = 'text/javascript';
    script.src = src;
    script.id = id;
    renderer.appendChild(this.document.body, script);
    return script;
  }
}
